import { FC } from 'react';

type Props = {
	className?: string;
};

const NotificationIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.85225 8.14804C3.85225 4.75257 6.60482 2 10.0003 2C13.3957 2 16.1483 4.75257 16.1483 8.14804V10.139C16.1483 10.386 16.2465 10.6229 16.4212 10.7977L17.475 11.8516C17.5799 11.9563 17.6388 12.0985 17.6388 12.2467V13.2766C17.6388 13.7648 17.3637 14.2344 16.8889 14.4437C15.6444 14.9923 13.2445 15.7865 10.0003 15.7865C6.75606 15.7865 4.35614 14.9923 3.11164 14.4437C2.63686 14.2344 2.36182 13.7648 2.36182 13.2766V12.2467C2.36182 12.0985 2.4207 11.9563 2.52552 11.8516L3.57941 10.7977C3.75411 10.6229 3.85225 10.386 3.85225 10.139V8.14804Z'
				fill='inherit'
				stroke='transparent'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.13692 15.2275C8.13692 15.9549 8.84331 16.718 9.97902 16.718C11.1313 16.718 11.863 15.9407 11.863 15.2275H13.3534C13.3534 16.9839 11.7157 18.2084 9.97902 18.2084C8.22583 18.2084 6.64648 16.9696 6.64648 15.2275H8.13692Z'
				fill='inherit'
				stroke='transparent'
			/>
		</svg>
	);
};

export default NotificationIconSolid;
